/**
 * Toaster container sagas
 *
 * @author Rafael Guedes <rguedes@ubiwhere.com>
 *
 */

export default function* watcherSignin() {}
